import { useEffect, useState } from 'react';
import type { ReactFlowInstance } from 'reactflow';
import type { CustomNode } from '@src/components/custom-nodes/types';
import { recalculateNodesXPos } from '@src/scenario-editor/utils';
import { centerLayout } from '@src/scenario-editor/render-utils';
import { NODE_HEIGHT, NODE_WIDTH } from '@src/consts';

interface UseInitialNodesRecalculationProps {
  nodes: CustomNode[];
  setNodes: React.Dispatch<React.SetStateAction<CustomNode[]>>;
  reactFlowWrapper: React.RefObject<HTMLDivElement>;
  reactFlowInstance?: ReactFlowInstance;
}
export const useInitialNodesRecalculation = ({
    nodes,
    setNodes,
    reactFlowWrapper,
    reactFlowInstance
  }: UseInitialNodesRecalculationProps) => {
  const [initiallyRecalculated, setInitiallyRecalculated] = useState(false);

  useEffect(() => {
    const wrapperHeight = reactFlowWrapper?.current?.clientHeight ?? 0;

    if (reactFlowWrapper.current && !initiallyRecalculated && reactFlowInstance) {
      const wrapperWidth = reactFlowWrapper.current.clientWidth;

      setInitiallyRecalculated(true);
      setNodes(nodes => {
        const updatedNodes = recalculateNodesXPos(nodes, wrapperWidth, { instance: reactFlowInstance });

        return updatedNodes;
      });
    }

    setTimeout(() => {
      if (!reactFlowInstance || initiallyRecalculated) {
        return;
      }
      const node = reactFlowInstance?.getNodes()[0];
      const yCoord = wrapperHeight ? (wrapperHeight / 2 - NODE_HEIGHT) : node?.position?.y + NODE_HEIGHT / 2;


      centerLayout(reactFlowInstance)({ coords: { x: (node?.position?.x ?? 0) + NODE_WIDTH / 2, y: yCoord }});
    }, 0);
  }, [nodes, initiallyRecalculated, reactFlowWrapper, reactFlowInstance, setNodes]);
}
